module.exports = __webpack_public_path__ + "static/media/sausage.9d865e0d.svg";